import { ChainId } from "../../jibswap"
import MULTICALL_ABI from "./abi.json"
import { multicall } from "../../cypherium_address.json"

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.JIBCHAIN_MAINNET]: multicall,
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
